import styled from 'styled-components';

const Root = styled.div`
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  .material-symbols-rounded {
    font-size: 1.5rem;
    font-variation-settings: 'FILL' 1;
  }
  &.use {
    .material-symbols-rounded {
      color: var(--filled-green);
      &:hover {
        border-radius: 1rem;
        box-shadow: 0 0 0 2px var(--filled-green);
        background-color: var(--board);
      }
    }
  }

  &.green {
    .material-symbols-rounded {
      color: var(--filled-green);
      &:hover {
        box-shadow: 0 0 0 2px var(--filled-green);
      }
    }
  }

  &.blue {
    .material-symbols-rounded {
      color: var(--primary);
      &:hover {
        box-shadow: 0 0 0 2px var(--primary);
      }
    }
  }

  &.yellow {
    .material-symbols-rounded {
      color: var(--filled-yellow);
      &:hover {
        box-shadow: 0 0 0 2px var(--filled-yellow);
      }
    }
  }

  &.violet {
    .material-symbols-rounded {
      color: var(--filled-violet);
      &:hover {
        box-shadow: 0 0 0 2px var(--filled-violet);
      }
    }
  }

  &.red {
    .material-symbols-rounded {
      color: var(--filled-red);
      &:hover {
        box-shadow: 0 0 0 2px var(--filled-red);
      }
    }
  }

  &.normal {
    .material-symbols-rounded {
      color: var(--text-primary);
      &:hover {
        box-shadow: 0 0 0 2px var(--text-primary);
      }
    }
  }

  &.noUse {
    .material-symbols-rounded {
      color: var(--tonal-deep);
      &:hover {
        border-radius: 1rem;
        box-shadow: 0 0 0 1px var(--primary);
        background-color: var(--primary);
      }
    }
  }
`;

interface Props {
  use: boolean;
  color?: string;
}

const TableLamp = ({ use, color = 'green' }: Props) => {
  return (
    <Root //
      className={`${use ? 'use' : 'noUse'} ${color}`}
    >
      <span className='material-symbols-rounded'>{use ? 'check_circle' : 'circle'}</span>
    </Root>
  );
};

export default TableLamp;
